<template>
  <div class="flex flex-col items-center gap-2 p-4">
    <InkCorner :part="nidoLocal.parts.center" :can-be-corner="true" />
  </div>
</template>

<script lang="ts" setup>
import { NidoCorner } from '~/service/experience/world/nido/Nido'

const props = defineProps<{
  nido: NidoCorner
}>()

const nidoLocal = ref(props.nido)
</script>

<style lang="scss" scoped></style>
